var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9.772v16.515H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0)",
    stroke: "#fff",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 11.5,
    stroke: "none",
    rx: 12,
    ry: 11.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 11.5,
    fill: "none",
    rx: 11.35,
    ry: 10.85
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)",
    transform: "translate(7.114 3.214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.886 16.515-.535-1.025C4.201 15.2.641 8.355.09 5.665A4.463 4.463 0 0 1 1.068 1.9 5.1 5.1 0 0 1 4.886 0a5.094 5.094 0 0 1 3.815 1.9 4.464 4.464 0 0 1 .978 3.767c-.548 2.688-4.107 9.533-4.258 9.822Zm0-15.309A3.862 3.862 0 0 0 2.001 2.66a3.278 3.278 0 0 0-.73 2.763c.4 1.929 2.585 6.416 3.615 8.461 1.029-2.045 3.215-6.532 3.615-8.461A3.279 3.279 0 0 0 7.77 2.66a3.862 3.862 0 0 0-2.884-1.454Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.886 7.846a2.779 2.779 0 1 1 2.779-2.779 2.782 2.782 0 0 1-2.779 2.779m0-4.351a1.573 1.573 0 1 0 1.573 1.573 1.575 1.575 0 0 0-1.573-1.573"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMap);
export default __webpack_public_path__ + "static/media/active_map.717ce49ffca8c381a5344f90211292df.svg";
export { ForwardRef as ReactComponent };